import { render } from "./App.vue?vue&type=template&id=fd1d15de"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=fd1d15de&lang=scss"

import exportComponent from "/home/ubuntu/apps/synergy-login/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__